import VtexLib from '@/feature/vtex/vtex.lib';
import ZoomLib from '@/feature/zoom/zoom.lib';
import PrecodeLib from '@/feature/precode/precode.lib';
import CursologyLib from '@/feature/cursology/cursology.lib';
import GenLib from '@/feature/gen/gen.lib';
import NuvemShopLib from '@/feature/nuvemshop/nuvemshop.lib';

const eventHandlers = {
  vtex: VtexLib.eventHandler,
  zoom: ZoomLib.checkoutEventHandler,
  precode: PrecodeLib.eventHandler,
  cursology: CursologyLib.eventHandler,
  gen: GenLib.eventHandler,
  nuvemshop: NuvemShopLib.eventHandler,
};

const configs = {
  zoom: ZoomLib.checkoutCustomConfig,
  vtex: VtexLib.checkoutCustomConfig,
  precode: PrecodeLib.checkoutCustomConfig,
  cursology: CursologyLib.checkoutCustomConfig,
  gen: GenLib.checkoutCustomConfig,
  nuvemshop: NuvemShopLib.checkoutCustomConfig,
};

export default {
  getContextVariables(context) {
    return {
      eventHandler: eventHandlers[context],
      config: configs[context],
    };
  },
};
